// @flow

const AverageYearColumnName = process.env.REACT_APP_COLUMN_YEAR || 2025;
export const coach_player_stats = (round_id: number, is_preseason: boolean) => ({
	'coaches-choice': [
		{
			key: 'GP',
			prop: 'stats.games_played',
			tooltip: 'Games Played',
		},
		{
			key: 'AVG',
			prop: 'stats.avg_points',
			tooltip: 'Average Points',
		},
		{
			key: 'TP',
			prop: 'stats.total_points',
			tooltip: 'Total Points',
		},
		{
			key: '%C',
			prop: 'stats.selections_info.c',
			tooltip: '% Selected as Captain',
		},
		{
			key: '%VC',
			prop: 'stats.selections_info.vc',
			tooltip: ' % Selected as Vice Captain',
		},
		{
			key: '%Start',
			prop: 'stats.selections_info.start',
			tooltip: '% starting on field',
		},
		{
			key: '%Own',
			prop: 'stats.draft_owned_by',
			tooltip: ' % Owned by Total Draft Teams',
		},
		{
			key: 'Ownership % Change',
			prop: 'stats.draft_owned_by_change',
			tooltip: 'Change in Owned % this Round',
			is_owner_display: true,
		}
	],
	consistency: [
		{
			key: 'GP',
			prop: 'stats.games_played',
			tooltip: 'Games Played',
		},
		{
			key: 'AVG',
			prop: 'stats.avg_points',
			tooltip: 'Average Points',
		},
		{
			key: 'TP',
			prop: 'stats.total_points',
			tooltip: 'Total Points',
		},
		{
			key: 'L3 AVG',
			prop: 'stats.last_3_avg',
			tooltip: 'Average Score for Last 3 Games',

		},
		{
			key: 'L5 AVG',
			prop: 'stats.last_5_avg',
			tooltip: 'Last 5 Average',
		},
		{
			key: 'Cons',
			prop: 'stats.consistency',
			tooltip: 'Consistency Rating',
		},
		{
			key: '20 < AVG',
			prop: 'stats.in_20_avg',
			tooltip: 'No. of Scores 20 Less than Average Score',
		},
		{
			key: '20 > AVG',
			prop: 'stats.out_20_avg',
			tooltip: 'No. of Scores 20 Greater than Average Score',
		},
	],
	opposition: [
		{
			key: 'GP',
			prop: 'stats.games_played',
			tooltip: 'Games Played',
		},
		{
			key: 'AVG',
			prop: 'stats.avg_points',
			tooltip: 'Average Points',
		},
		{
			key: 'TP',
			prop: 'stats.total_points',
			tooltip: 'Total Points',
		},
		{
			key: 'OPP AVG',
			prop: 'stats.opp_avg_one_round_after_current',
			prop_sub: 'stats.opp_one_round_after_current',
			tooltip: 'Average against upcoming Opponent',
		},
		{
			key: 'OPP AVG 2W',
			prop: 'stats.opp_avg_two_rounds_after_current',
			prop_sub: 'stats.opp_two_rounds_after_current',
			tooltip: 'Average against upcoming opponent in 2 weeks',
		},
		{
			key: 'OPP AVG 3W',
			prop: 'stats.opp_avg_three_rounds_after_current',
			prop_sub: 'stats.opp_three_rounds_after_current',
			tooltip: 'Average against upcoming opponent in 3 weeks',
		},
		{
			key: 'N3 OPP AVG',
			prop: 'stats.opp_avg_3_rounds',
			tooltip: 'Average Against Next 3 Opponents',
		},
	],
	venues: [
		{
			key: 'GP',
			prop: 'stats.games_played',
			tooltip: 'Games Played',
		},
		{
			key: 'AVG',
			prop: 'stats.avg_points',
			tooltip: 'Average Points',
		},
		{
			key: 'TP',
			prop: 'stats.total_points',
			tooltip: 'Total Points',
		},
		{
			key: 'VEN AVG',
			prop: 'stats.venue_avg_one_round_after_current',
			prop_sub: 'stats.venue_one_round_after_current',
			tooltip: 'Average at upcoming game venue',
		},
		{
			key: 'VEN AVG 2W',
			prop: 'stats.venue_avg_two_rounds_after_current',
			prop_sub: 'stats.venue_two_rounds_after_current',
			tooltip: 'Average at upcoming game venue in 2 weeks'
		},
		{
			key: 'VEN AVG 3W',
			prop: 'stats.venue_avg_three_rounds_after_current',
			prop_sub: 'stats.venue_three_rounds_after_current',
			tooltip: 'Average at upcoming game venue in 3 weeks',
		},
		{
			key: 'N3 VEN AVG',
			prop: 'stats.venue_avg_3_rounds',
			tooltip: 'Average at Next Three Game Venues',
		},
	],
	form: [
		{
			key: 'GP',
			prop: 'stats.games_played',
			tooltip: 'Games Played',
		},
		{
			key: 'AVG',
			prop: 'stats.avg_points',
			tooltip: 'Average Points',
		},
		{
			key: 'TP',
			prop: 'stats.total_points',
			tooltip: 'Total Points',
		},
		{
			key: `Round ${round_id - 1}`,
			prop: 'stats.points_last_round',
			tooltip: 'Previous Round Score',
			hide: round_id < 2 || is_preseason
		},
		{
			key: `Round ${round_id - 2}`,
			prop: 'stats.points_2_rounds_prior',
			tooltip: 'Score from 2 Rounds Prior',
			hide: round_id < 3 || is_preseason
		},
		{
			key: `Round ${round_id - 3}`,
			prop: 'stats.points_3_rounds_prior',
			tooltip: 'Score From 3 Round Prior',
			hide: round_id < 4 || is_preseason
		},
		{
			key: `${AverageYearColumnName} Round ${round_id}` ,
			prop: `stats.last_season_scores.${round_id}`,
			tooltip: `${AverageYearColumnName} RD ${round_id} Score`,
			hide: !is_preseason
		},
		{
			key: `${AverageYearColumnName} Round ${round_id - 1}`,
			prop: `stats.last_season_scores.${round_id - 1}`,
			tooltip: `${AverageYearColumnName} RD ${round_id - 1} Score`,
			hide: !is_preseason
		},
		{
			key: `${AverageYearColumnName} Round ${round_id - 2}`,
			prop: `stats.last_season_scores.${round_id - 2}`,
			tooltip: `${AverageYearColumnName} RD ${round_id - 2} Score`,
			hide: !is_preseason
		},
		{
			key: 'L3 PA',
			prop: 'stats.last_3_proj_avg',
			tooltip: 'Projected Average Last 3 Rounds',
		},
		{
			key: 'L3A vs L3PA',
			prop: 'stats.last_3_avg_vs_proj',
			tooltip: 'Difference Between Average Last 3 Scores and the Projection',
		},
	],
});

export const team_trade_coach_player_stats = {
	'coaches-choice': [
		{
			key: 'AVG',
			prop: 'stats.avg_points',
			tooltip: 'Average Points',
		},
		{
			key: '% as C',
			prop: 'stats.selections_info.c',
			tooltip: '% as captain',
		},
		{
			key: '% as VC',
			prop: 'stats.selections_info.vc',
			tooltip: '% as VC',
		},
		{
			key: '% Starting',
			prop: 'stats.selections_info.start',
			tooltip: '% starting on field',
		},
	],
	consistency: [
		{
			key: 'AVG',
			prop: 'stats.avg_points',
			tooltip: 'Average Points',
		},
		{
			key: 'L3 AVG',
			prop: 'stats.last_3_avg',
			tooltip: 'Average Score for Last 3 Games',

		},
		{
			key: 'L5 AVG',
			prop: 'stats.last_5_avg',
			tooltip: 'Last 5 Average',
		},
		{
			key: 'Cons',
			prop: 'stats.consistency',
			tooltip: 'Consistency Rating',
		},
	],
	opposition: [
		{
			key: 'GP',
			prop: 'stats.games_played',
			tooltip: 'Games Played',
		},
		{
			key: 'AVG',
			prop: 'stats.avg_points',
			tooltip: 'Average Points',
		},
		{
			key: 'TP',
			prop: 'stats.total_points',
			tooltip: 'Total Points',
		},
		{
			key: 'N3 OPP AVG',
			prop: 'stats.opp_avg_3_rounds',
			tooltip: 'Average Against Next 3 Opponents',
		},
	],
	venues: [
		{
			key: 'GP',
			prop: 'stats.games_played',
			tooltip: 'Games Played',
		},
		{
			key: 'AVG',
			prop: 'stats.avg_points',
			tooltip: 'Average Points',
		},
		{
			key: 'TP',
			prop: 'stats.total_points',
			tooltip: 'Total Points',
		},
		{
			key: 'N3 VEN AVG',
			prop: 'stats.venue_avg_3_rounds',
			tooltip: 'Average at Next Three Game Venues',
		},
	],
	form: [
		{
			key: 'AVG',
			prop: 'stats.avg_points',
			tooltip: 'Average Points',
		},
		{
			key: 'Last RD Score',
			prop: 'stats.points_last_round',
			tooltip: 'Previous Round Score',
		},
		{
			key: 'L3 Proj AVG',
			prop: 'stats.last_3_proj_avg',
			tooltip: 'Last 3 projected average',
		},
		{
			key: 'L3 AVG vs L3 Proj AVG',
			prop: 'stats.last_3_avg_vs_proj',
			tooltip: 'Difference Between Average Last 3 Scores and the Projection',
		},
	],
};


export const basic_player_stats = (round_id: number, is_preseason: boolean) => ({
	'basic': [
		{
			key: 'GP',
			prop: 'stats.games_played',
			tooltip: 'Games Played'
		},
		{
			key: 'AVG',
			prop: 'stats.avg_points',
			tooltip: 'Average Round Score'
		},
		{
			key: 'TP',
			prop: 'stats.total_points',
			tooltip: 'Total Points Scored'
		},
		{
			key: `RD ${round_id - 1}`,
			prop: 'stats.points_last_round',
			tooltip: 'Previous Round Score',
			hide: !round_id || round_id < 2 || is_preseason
		},
		{
			key: `RD ${round_id - 2}`,
			prop: 'stats.points_2_rounds_prior',
			tooltip: 'Score from 2 Rounds Prior',
			hide: !round_id || round_id < 3 || is_preseason
		},
		{
			key: `RD ${round_id - 3}`,
			prop: 'stats.points_3_rounds_prior',
			tooltip: 'Score From 3 Round Prior',
			hide: !round_id || round_id < 4 || is_preseason
		},
		{
			key: `${AverageYearColumnName} RD ${round_id}` ,
			prop: `stats.last_season_scores.${round_id}`,
			tooltip: `${AverageYearColumnName} RD ${round_id} Score`,
			hide: !is_preseason
		},
		{
			key: `${AverageYearColumnName} RD ${round_id - 1}`,
			prop: `stats.last_season_scores.${round_id - 1}`,
			tooltip: `${AverageYearColumnName} RD ${round_id - 1} Score`,
			hide: !is_preseason
		},
		{
			key: `${AverageYearColumnName} RD ${round_id - 2}`,
			prop: `stats.last_season_scores.${round_id - 2}`,
			tooltip: `${AverageYearColumnName} RD ${round_id - 2} Score`,
			hide: !is_preseason
		},
		{
			key: 'L3 AVG',
			prop: 'stats.last_3_avg',
			tooltip: 'Average Score for Last 3 Games'
		}
	]
});


// WEBPACK FOOTER //
// ./src/helpers/stats/index.js